import React from "react";
import { Link } from 'react-router-dom';

import { LiftBrandTokenProvider } from "@lift/design-system-react-web/dist/contexts";
import LftTypography from "@lift/design-system-react-web/dist/components/LftTypography";
import LftShortcut from "@lift/design-system-react-web/dist/components/LftShortcut";
import LftList from "@lift/design-system-react-web/dist/components/LftList";
import LftLogotipo from '@lift/design-system-react-web/dist/components/LftLogotipo';

import Type from "@lift/assets/dist/assets/icons/type";
import Video from "@lift/assets/dist/assets/icons/video";
import Code from "@lift/assets/dist/assets/icons/code";
import MessageSquare  from "@lift/assets/dist/assets/icons/message_square";

import "@lift/design-tokens/dist/css/globals.css";
import "@lift/design-tokens/dist/css/yduqs/default.css";

import { ReactComponent as LiftIcon } from "../images/lift-icon.svg";
import { ReactComponent as LiftLogo } from "../images/lift-logo.svg";
// import { ReactComponent as YduqsLogo } from "../images/logo-yduqs.svg";

import { AppWrapper, AppFrame, ContentWrapper, HeaderWrapper, SectionWrapper, LinksWrapper, LinkWrapper, ListsWrapper, FooterWrapper } from "../styles/Home.styles";

import { useViewport } from "../utils";

const marca = "yduqs";

function Home() {
    const { width } = useViewport();
    const breakpoint = 820;

    const openInNewTab = (url: string) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <LiftBrandTokenProvider brand={marca} template="default">
            <AppWrapper>
                <AppFrame>
                    <HeaderWrapper>
                        <LiftLogo />
                        <LiftIcon />
                    </HeaderWrapper>
                    <SectionWrapper>
                        <ContentWrapper>
                            <LftTypography component="title" variant="h1" size="medium" bgColor>
                                Ecossistema de bibliotecas para equalizar, criar e evoluir produtos e projetos
                            </LftTypography>
                            <br/>
                            <LftTypography component="paragraph" size="large" bgColor>
                                Lift Design System é um produto que conecta ferramentas, processos e linguagens, trabalhando de forma orquestrada.
                            </LftTypography>
                        </ContentWrapper>
                        <ContentWrapper>
                            <LftTypography component="paragraph" variant="h1" size="small" bgColor>
                                Link úteis para acessar:
                            </LftTypography>
                            {width > breakpoint ? (
                                <LinksWrapper>
                                    <LinkWrapper>
                                        <LftShortcut icon={MessageSquare} lftClick={() => openInNewTab("https://teams.microsoft.com/l/team/19:cV6U_EMMHJGigVZ7oSSHKESfMjFZh1VudkcMjVh6znU1%40thread.tacv2/conversations?groupId=b69bb6e4-24bc-4ed3-976e-fcb40d2b0b82&tenantId=29e081cc-983f-4d52-b1d0-103595213bc6")}>
                                            Comunidade
                                        </LftShortcut>
                                    </LinkWrapper>
                                    <LinkWrapper>
                                        <LftShortcut icon={Code} lftClick={() => openInNewTab("https://lift.yduqs.com.br/doc/index.html")}>
                                            Componentes
                                        </LftShortcut>
                                    </LinkWrapper>
                                    <LinkWrapper>
                                        <LftShortcut icon={Video} lftClick={() => openInNewTab("https://web.microsoftstream.com/group/b69bb6e4-24bc-4ed3-976e-fcb40d2b0b82")}>
                                            Vídeos
                                        </LftShortcut>
                                    </LinkWrapper>
                                    <LinkWrapper>
                                        <Link to="/writing" style={{ textDecoration: 'none' }}>
                                            <LftShortcut icon={Type}>
                                                 Writing
                                            </LftShortcut>
                                       </Link>
                                    </LinkWrapper>
                                </LinksWrapper>
                            ) : (
                                <ListsWrapper>
                                    <LftList title="Comunidade" trailingIcon={true} leadingIcon={MessageSquare} onClick={() => openInNewTab("https://teams.microsoft.com/l/team/19:cV6U_EMMHJGigVZ7oSSHKESfMjFZh1VudkcMjVh6znU1%40thread.tacv2/conversations?groupId=b69bb6e4-24bc-4ed3-976e-fcb40d2b0b82&tenantId=29e081cc-983f-4d52-b1d0-103595213bc6")} bgColor />
                                    <LftList title="Componentes" trailingIcon={true} leadingIcon={Code} onClick={() => openInNewTab("https://lift.yduqs.com.br/doc/index.html")} bgColor />
                                    <LftList title="Vídeos" trailingIcon={true} leadingIcon={Video} onClick={() => openInNewTab("https://web.microsoftstream.com/group/b69bb6e4-24bc-4ed3-976e-fcb40d2b0b82")} bgColor />
                                    <Link to="/writing">
                                      <LftList title="Type" trailingIcon={true} leadingIcon={Type} bgColor />
                                    </Link>
                                </ListsWrapper>
                            )}
                        </ContentWrapper>
                        <FooterWrapper>
                            <LftTypography component="paragraph" variant="h1" size="small" bgColor>
                                Orgulhosamente criado pela:
                            </LftTypography>
                            <LftLogotipo id="logotipo" version='negative' bgColor={false} alt="Yduqs" />
                        </FooterWrapper>
                    </SectionWrapper>
                </AppFrame>
            </AppWrapper>
        </LiftBrandTokenProvider>
    );
}

export default Home;